import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { foldSelections } from 'pluginServices/editorState/selectors';
import { getSelectedCoursewareItems, getClipboard } from 'pluginServices/selectionState/selectors';
import { CopyContainer } from './component';
import { getClip, setClip } from './helpers';

const mapStateToProps = createStructuredSelector({
  selections: getSelectedCoursewareItems,
  clipboard: getClipboard,
  editorState: foldSelections,
});

export default connect(mapStateToProps)(CopyContainer);

export {
  CopyContainer,
  getClip,
  getSelectedCoursewareItems,
  setClip,
};
